import React, { useEffect } from "react";

const PunchesTown2026 = () => {

  useEffect(() => {
    document.title = "Punches Town 2026 | Your Friend My Friend";

    const container = document.getElementById("ft-widget");
    if (container) {
      container.innerHTML = "";
    }

    // Create script
    const script = document.createElement("script");
    script.src = "https://embed.futureticketing.ie/ft5262a6bee7bb0";
    script.type = "text/javascript";
    script.async = true;

    // IMPORTANT for iPhone Safari
    script.referrerPolicy = "origin";

    script.onload = () => {
      if (window.FT) {
        window.FTicket = window.FT({
          FT_event: "416"
        });
      }
    };

    if (container) {
      container.appendChild(script);
    }

    // Cleanup
    return () => {
      if (container) {
        container.innerHTML = "";
      }
    };

  }, []);

  return (
    <div style={{ padding: "40px 20px" }}>
      {/* Future Ticketing will inject widget here */}
      <div id="ft-widget"></div>
    </div>
  );
};

export default PunchesTown2026;
